import { render, staticRenderFns } from "./ChooseSeatPage.vue?vue&type=template&id=1b691747&scoped=true"
import script from "./ChooseSeatPage.vue?vue&type=script&lang=js"
export * from "./ChooseSeatPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b691747",
  null
  
)

export default component.exports